import React, { Component } from 'react';

// This list comes from the good practice guide of managing odour producing environments
// https://www.mfe.govt.nz/sites/default/files/media/Air/good-practice-guide-odour.pdf
const options =
    [
        'Fragrant, Perfumy, Sweet',
        'Rubbish',
        'Compost, Silage, Herbal, cut grass',
        'Meaty, Rancid, Dead Animal, decayed',
        'Sea/marine, Fishy',
        'Smoky, woody, resinous',
        'Gasoline, solvent, oily',
        'Soapy, Chemical, Paint-like',
        'Sewer odour',
        'Faecal, Sickening',
        'Cooked food, Coffee, Bakery',
        'Other'
    ]

// NOTE: this is the full list from MFE but we decided on a pragmatic subset for our next test
// [
// 'Fragrant',
// 'Perfumy',
// 'Sweet',
// 'Fruity',
// 'Bakery (Fresh bread)',
// 'Coffee-like',
// 'Spicy',
// 'Meaty',
// 'Sea/marine',
// 'Herbal, green, cut grass',
// 'Bark-like',
// 'Woody, resinous',
// 'Medicinal',
// 'Burnt, smoky',
// 'Soapy',
// 'Garlic, onion',
// 'Cooked vegetables',
// 'Chemical',
// 'Etherish, anaesthetic',
// 'Sour, acrid, vinegar',
// 'Like blood, raw meat',
// 'Rubbish',
// 'Compost',
// 'Silage',
// 'Sickening',
// 'Musty, earthy, mouldy',
// 'Sharp, pungent, acid',
// 'Metallic',
// 'Tar-like',
// 'Oily, fatty',
// 'Like gasoline, solvent',
// 'Fishy',
// 'Putrid, foul, decayed',
// 'Paint-like',
// 'Rancid',
// 'Sulphur smelling',
// 'Dead animal',
// 'Faecal (like manure)',
// 'Sewer odour'
// ]

function makeCheckbox({ key, onChange, checked }) {
    let groupItemClassName = checked ? 'checkbox-group__item checkbox-group__item-active' : 'checkbox-group__item'
    return (<div className={groupItemClassName} key={key}>
        <input checked={checked} onChange={onChange} type="checkbox" id={key} key={key} value={key}></input>
        <label htmlFor={key}>{key}</label>
    </div>)
}
class OdourCharacterSelect extends Component {
    state = {
        selected: [],
    }
    constructor() {
        super()
        this.onChange = this.onChange.bind(this)
    }
    onChange(ev) {
        const value = ev.target.value;
        let selected = this.state.selected;
        if (!ev.target.checked) {
            selected = selected.filter(e => e !== value)
        } else {
            selected.push(value)
        }
        this.setState({ selected })
        if (this.props.onChange) {
            this.props.onChange(selected)
        }
    }
    render() {

        const opts = options
            .map(opt => {
                const checked = !!this.state.selected.find(v => v === opt)
                return { key: opt, onChange: this.onChange, checked }
            })
            .map(makeCheckbox)

        return (<div className='checkbox-group'>{opts}</div>);
    }
}
export default OdourCharacterSelect;